export default {
  'verificationcheck.verifycode': 'Verificare il codice',
  'verificationcheck.gotoprofile': 'Vai al profilo',
  'verificationcheck.entercode': 'Inserisci il codice di verifica',
  'verificationcheck.maintext':
    'Per continuare inserisci qui il codice di verifica, il codice è stato inviato a',
  'To continue please enter verification code here, the code has been sent to':
    'Per continuare inserisci qui il codice di verifica, il codice è stato inviato a',
  'verificationcheck.evaluate': 'VALUTARE',
  'verificationcheck.resendcode': 'Clicca per inviare nuovamente il codice',
};
